import { ConfirmPartnerMaterialUploadRequestSchema, ConfirmPartnerMaterialUploadResponseSchema } from './confirm-partner-material-upload.schema';
export const confirmPartnerMaterialUploadContract = {
    method: 'POST',
    path: '/api/v2/admin/partner-materials/:id/files/:locale',
    description: 'Attach an uploaded PDF to one language',
    requestSchema: ConfirmPartnerMaterialUploadRequestSchema,
    responseSchema: ConfirmPartnerMaterialUploadResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - upload does not match the handed-out key',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner material not found'
        }
    }
};

//# sourceMappingURL=confirm-partner-material-upload.contract.js.map